<div class="veiledning">
  <p>
    <span>{{ "Hvis du velger å ikke publisere møte/protokoll, vil kun"|translate }} </span>
    <span class="tekst-med-tooltip" [matTooltip]="medlemmerMedTilgangTilIkkePublisert">{{ "disse gruppemedlemmene"|translate }} </span>
    <span>{{ "ha tilgang til møtet/protokollen."|translate }}</span>
  </p>
  <p>{{ "Når du har opprettet møtet, kan du når som helst velge å publisere møte/protokoll, og du kan sende innkalling når det passer deg best."|translate }}</p>
</div>

<fieldset>
  <div class="feltrad">
    <mat-slide-toggle [formControl]="skjema.controls.erMoetePublisert" class="e2e-erMoetePublisert"
                      matTooltip="{{'Medlemmer uten tilgang til ikke-publisert informasjon vil ikke kunne se møte- og saksdetaljer for ikke-publisert møte'|translate}}">
      {{ "Publiser møte"|translate }}
    </mat-slide-toggle>
    @if(skjema.controls.erMoetePublisert.value){
    <mat-slide-toggle [formControl]="skjema.controls.erProtokollPublisert" class="e2e-erProtokollPublisert"
                      matTooltip="{{'Medlemmer uten tilgang til ikke-publisert informasjon vil ikke kunne se protokolltekst for ikke-publisert protokoll'|translate}}">
      {{ "Publiser protokoll"|translate }}
    </mat-slide-toggle>
    }
  </div>

  <div class="feltrad">
    <mat-slide-toggle [formControl]="skjema.controls.sendInnkalling" [matTooltip]="sendInnkallingTooltip()">
      {{ "Send e-post med møteinnkalling"|translate }}
    </mat-slide-toggle>
  </div>
</fieldset>
